<template>
  <svg class="w-5 h-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
    <path
      d="M14 2V8H20"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
    <path
      d="M15 11V17C15 17.5304 14.7893 18.0391 14.4142 18.4142C14.0391 18.7893 13.5304 19 13 19C12.4696 19 11.9609 18.7893 11.5858 18.4142C11.2107 18.0391 11 17.5304 11 17C11 16.4696 11.2107 15.9609 11.5858 15.5858C11.9609 15.2107 12.4696 15 13 15C13.35 15 13.68 15.08 14 15.22V12H15Z"
      fill="currentColor"
    ></path>
    <path d="M15 12V11L16 10.5V13L15 12Z" fill="currentColor"></path>
    <line
      x1="15"
      y1="11"
      x2="16"
      y2="10.5"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
    ></line>
  </svg>
</template>

<script>
export default {
  name: 'AudioFileIcon',
}
</script>
